'use client';

import clsx from 'clsx';
import {
  EmblaCarouselType,
  EmblaOptionsType,
  EmblaPluginType,
} from 'embla-carousel';
import useEmblaCarousel from 'embla-carousel-react';

import { PropsWithChildren, useEffect } from 'react';

import { carousel, slides } from './carousel.css';

type CarouselProps = PropsWithChildren<{
  options?: EmblaOptionsType;
  plugins?: EmblaPluginType[];
  classNames?: { carousel?: string; slides?: string };
  emblaApiRef?: (api: EmblaCarouselType) => void;
}>;

export function Carousel({
  children,
  options,
  plugins,
  classNames,
  emblaApiRef,
}: CarouselProps) {
  const [emblaRef, emblaApi] = useEmblaCarousel(options, plugins);

  useEffect(() => {
    if (emblaApiRef !== undefined && emblaApi !== undefined) {
      emblaApiRef(emblaApi);
    }
  }, [emblaApi, emblaApiRef]);

  return (
    <section className={clsx(carousel, classNames?.carousel)} ref={emblaRef}>
      <section className={clsx(slides, classNames?.slides)}>{children}</section>
    </section>
  );
}
